import { httpGet } from './http';
import { transformMilestone, BackendMilestone, FrontendMilestone } from './transform';

export type { FrontendMilestone };

// 获取所有里程碑
export async function getPublicMilestones(): Promise<FrontendMilestone[]> {
  const response = await httpGet<BackendMilestone[]>('/public/milestones');
  return (response || []).map(transformMilestone);
}

// 获取里程碑详情
export async function getMilestoneById(id: number): Promise<FrontendMilestone | null> {
  try {
    const response = await httpGet<BackendMilestone>(`/public/milestones/${id}`);
    return transformMilestone(response);
  } catch {
    return null;
  }
}
